import * as Models from '../commonModels';
import { CustomerPreviewModel } from '../customer/customer';


export class UserModel extends Models.ResponseBase {
  User: User;
}

export class UserDictionaryListModel extends Models.ResponseBase {
  Items: UserPreviewModel[];
}

export class UserPreviewModel {
  public UserId: number;
  public Name: string;
  public Mail: string;
  public Telephone: string;
}

export class UserEditModel {
  UserId: number;
  UserTypeId: number;
  IsActive: boolean;
  GarageId: number;
  CustomerId: number;
  CustomerName: string;
  FirstName: string;
  LastName: string;
  Login: string;
  Mail: string;
  Telephone: string;
  Password: string;
  IsAldPanel: boolean;
  OrderViewOnly: boolean;
  HasCostEstimateNotifying: boolean;
  HasPollAccess: boolean;
  HasCostEstimateEmailSend: boolean;
  NoPersonalData: boolean;
  AvatarId: string;
  AddedByUser: string;
  AddDate: Date;
  DisactiveDate: Date;
  AdministratorRoleId: number;
  AdministratorRole: string;
  CustomerRoleId: number;
  CustomerRole: string;
  CustomerUserTypeId: number;
  UserType: string;
  IsSendInvoice: boolean;
  IsSendOffert: boolean;
  IsSendSpecificationNote: boolean;
  IsSendOrderNote: boolean;

  Avatar: string | ArrayBuffer;
  TyreSupplierId: number;

  public fullName(): string {
    return `${this.FirstName} ${this.LastName}`;
  }
}

// TODO Migrate to UserEditModel
export class User {
  FirstName: string;
  LastName: string;
  Username: string;
  Password: string;
  UserType: string;
  Token?: string;
  CompanyName: string;
  CanChangeCompany: boolean;
  GarageId: number;
  CustomerId: number;
  ContextGarageId: number;
  ContextCustomerId: number;
  isDisactive: boolean;
  isContractActive: boolean = true;
  Avatar: string | ArrayBuffer;
  UserTypeId: number;
  CustomerUserTypeId: number;
  public Permissions: number[];
  CarId: number;
  RegistrationNumber: string;
  TyreSupplierId: number;
  TFATelephone: string;
  TFAToken: string;
  TFACode: string;
  TFACodeStatus: TFACodeStatusTypes;
  TFAMessage: string;
}

export class UserPreviewListModel {
  UserId: number;
  UserTypeId: number;
  IsActive: boolean;
  NoPersonalData: boolean;
  GarageId: number;
  CustomerId: number;
  Login: string;
  FirstName: string;
  LastName: string;
  Mail: string;
  Telephone: string;
  DisactiveDate: Date;
  AddDate: Date;
  IsAldPanel: boolean;
  IsSendInvoice: boolean;
  IsSendOffert: boolean;
  OrderViewOnly: boolean;
  AddedByUser: string;
  HasPollAccess: boolean;
  Avatar: string | ArrayBuffer;
  AdministratorRole: string;
  AdministratorRoleId: number | null;
  CustomerRole: string;
  CustomerRoleId: number | null;
  CustomerUserTypeId: number;
  IsSendSpecificationNote: boolean;
  IsSendOrderNote: boolean;


  IsSelectedVirtual: boolean = false;
  TyreSupplierId: number;
}

export class UserSearchModel extends Models.SearchBaseModel {
  UserId: number;
  UserTypeId: number;
  GarageId: number;
  CstomerId: number;
  FirstName: string;
  LastName: string;
  Mail: string;
  IsGuardian: boolean;
  CustomerId: number;
  IsActive: boolean;
  IsSendInvoice: boolean;
  TyreSupplierId: number;
}

// Typ uzytkownika klienta. Odpowiada PointS.BL.Models.Enum.User.CustomerUserType.
// Standard oznacza brak ograniczen; pozostale wartosci wybieraja profil panelu customer-lite.
export enum CustomerUserType {
  Standard = 1,
  CallCenter = 2,
  TyreOrders = 3
}

// Etykiety typu uzytkownika klienta. Trzymamy je obok enuma, zeby formularz edycji
// i lista uzytkownikow nie rozjechaly sie nazwami.
export const CustomerUserTypes: Models.DictionaryModel[] = [
  { Id: CustomerUserType.Standard, Label: 'Zwykły użytkownik', Data: null, IsDefault: true },
  { Id: CustomerUserType.CallCenter, Label: 'Call center', Data: null, IsDefault: false },
  { Id: CustomerUserType.TyreOrders, Label: 'Podgląd zamówień opon', Data: null, IsDefault: false }
];

export enum TFACodeStatusTypes {
  None = 0,
  OK = 1,
  Error = 2,
  CodeAlreadySend = 3, 
  IncorrectCode = 4,
  TokenExpired = 5,
  SMSError = 6,
  CodeExpired = 7
}
